/* Copyright(c) 2023 APSS Media Pvt. Ltd.
 *  All Rights Reserved
 */

/**
 * @file VerifierNavPage 
 * @author  Aman Shaikh - 4660
 * @version 1.0
 * @section DESCRIPTION Navigation bar for multiple role users login switch Page 
 */

import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { logoutUser } from "../login/authentication";
import { withRouter } from "react-router-dom";
import Footer from "../layouts/footer";
import { fetch_custom as fetch } from "../../configration/fetch_default_headers"; //Akash-bug-4139

class Navigation extends React.Component {
  onLogout(e) {
    e.preventDefault();
    //Sonali-3809-logout from LiByAi page--placing removeCookies function befor userLogout
    fetch("/removeCookie", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    })
      .then((res) => res.json())
      .then((response) => { })
      .catch((e) => console.log(e)); //Somnath Task-3936, Add catch block to catch error

    //const { isAuthenticated, user } = this.props.auth;  //Chaitanya-4751-Removed Console Warning
    let data = {
      //user: user, //Akash-bug-4139 removed user
    };
    fetch("users/userLogout", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((response) => { })
      .catch((e) => console.log(e)); //Somnath Task-3936, Add catch block to catch error

    this.props.logoutUser(this.props.history);
    localStorage.removeItem("activeKey");
  }

  render() {
    const { isAuthenticated, user } = this.props.auth;
    return (
      <div>
        <nav
          className="navbar navbar-expand-md navbar-dark navbar-fixed-top shadow"
          id="navbar_navpage_font_css"
        >
           {/* rutuja-5131- Add leads -nexus logo image*/}
          <img
            src="Leads-Nexus.png"
            alt="Leads-Nexus"
            height="50px"
            width="200px"
            id="navbar_navpage_logo_css"
          ></img>

          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
          >
            <span class="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            {/* Aman Task - 4660 -(Role & Name after login) PC/PNC-Login - Client Switch option */}
            {isAuthenticated ? (
              <h5
                style={{
                  fontWeight: "10px",
                  fontStyle: "bold",
                  color: "white",
                  textAlign: "right",
                }}
              >
                Welcome &nbsp;&nbsp;{" "}
                <b style={{ color: "#00FF00" }}>
                  {" "}
                  {user.firstName}&nbsp;{user.lastName}
                </b>
                &nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp;
                {user.role === "Verifier" ? "Verifier" : ""}
              </h5>
            )
            : (
              ""
            )}

            {/* Aman Task - 4660 -(LogOut Button) PC/PNC-Login - Client Switch option */}
            <div className="navbar-nav navbar-right">
                {user.role === "Verifier" ? (
                <>
                   
                </>
              ) : (
                ""
              )}
              &nbsp;&nbsp;
              
              &nbsp;&nbsp;&nbsp;&nbsp;
                <li class="nav-item" style={{listStyle: "none", marginRight: "20px"}}>
                    <a
                        class="abc nav-link"
                        style={{ color: "aliceblue" }}
                        href="#/" //Chaitanya-4751-Removed Console Warning
                        onClick={this.onLogout.bind(this)}
                    >
                        {" "}
                        <span
                        class="glyphicon glyphicon-log-out"
                        style={{ color: "aliceblue" }}
                        ></span>
                    </a>
                </li>
            </div>
          </div>
        </nav>
     <Footer/> 
      </div>
    );
  }
}
/**
 * @author Narendra Phadke
 * @param  Description handle the login authentication
 * @return Description return All details of authentication
 */
Navigation.propTypes = {
  logoutUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});
export default connect(mapStateToProps, { logoutUser })(withRouter(Navigation));
